import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/state';
import { GridContainer, GridItem, ListingItemDialog, ServiceRequestDialog} from 'components';
import Typography from '@material-ui/core/Typography';
import { upsellImages } from '../../mock/mockUpsellData';
import { serviceImages } from '../../mock/mockUpsellData';
import { UpsellItemCard, HotelServiceCard } from 'components';
import { UpsellTitles } from 'models/backend/constant/Upsell';
import { ServiceTitles } from 'models/backend/constant/Upsell';
import { IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getVerbiage } from 'utils/stringHelper';
interface IProps {}

export const UpsellCardList: React.FC<IProps> = () => {

  const { selectedReservation } = useSelector((state: RootState) => state.reservationState);
  const { verbiages } = useSelector((state: RootState) => state.verbiages);
  const [title, setTitle] = React.useState('');
  const [openListingItemDialog, setOpenListingItemDialog] = React.useState(false);
  const [openServiceRequestDialog, setOpenServiceRequestDialog] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [openSnackBar, setOpenSnackBar] = React.useState(false);
  
  const handleClose = () => {
    setMessage('');
    setOpenSnackBar(false);
  };

  const onUpsellPurchaseCompleted = async (isCompleted: boolean, snackBarMessage: string) => {
    setOpenListingItemDialog(false);
      if(isCompleted === true){
        if(snackBarMessage != ""){
          setMessage(snackBarMessage + " Added");          
        }        
        else{
          setMessage("No Items Added!"); 
        }
        setOpenSnackBar(true);
      }
  };

  const onServiceRequestCompleted = async (isCompleted: boolean, snackBarMessage: string) => {
    setOpenServiceRequestDialog(false);
      if(isCompleted === true){
        if(snackBarMessage != ""){
          setMessage(snackBarMessage);          
        }        
        else{
          setMessage("No Service Requested!"); 
        }
        setOpenSnackBar(true);
      }
  };

  const handleOnButtonClick = (title: string): React.MouseEventHandler<HTMLButtonElement> | undefined => ()=> {
    switch(title){
      case UpsellTitles.RoomUpgrade:
        setOpenListingItemDialog(true);
        setTitle(UpsellTitles.RoomUpgrade);
        break;

      case UpsellTitles.RoomService:
        setOpenListingItemDialog(true);
        setTitle(UpsellTitles.RoomService);
        break;

      case UpsellTitles.LateCheckOut:
        setOpenServiceRequestDialog(true);
        setTitle(UpsellTitles.LateCheckOut);
        break;

      case UpsellTitles.FacilitiesBooking:
        setOpenListingItemDialog(true);
        setTitle(UpsellTitles.FacilitiesBooking);
        break;

      case UpsellTitles.Events:
        window.open('https://www.klook.com/en-SG/search/result/?query=singapore&spm=Home.TopNavigation.SearchInput&clickId=53981abf7d', '_blank');            
        break;

      case ServiceTitles.MorningCall:
        setOpenServiceRequestDialog(true);
        setTitle(ServiceTitles.MorningCall);
        break;

      case ServiceTitles.Amenities: 
        setOpenListingItemDialog(true);
        setTitle(ServiceTitles.Amenities);
        break;

      case ServiceTitles.Housekeeping:
        setOpenServiceRequestDialog(true);
        setTitle(ServiceTitles.Housekeeping);
        break;

      case ServiceTitles.RoomControl:
        setOpenServiceRequestDialog(true);
        setTitle(ServiceTitles.RoomControl);
        break;

      case ServiceTitles.WhatsApp:
        window.open('https://api.whatsapp.com/send/?phone=%2B6588888888&text&type=phone_number&app_absent=0', '_blank');
        break;
      
      case ServiceTitles.Call:
        window.open("tel:555-555-5555", '_blank');
        break;
      // default: 
      // setOpenListingItemDialog(true);
    }
  };

  return (
    <>
      <ListingItemDialog
        open={openListingItemDialog}
        onCompleted={onUpsellPurchaseCompleted}
        title = {title}
      />

      <ServiceRequestDialog
        open={openServiceRequestDialog}
        onCompleted={onServiceRequestCompleted}
        title = {title}
      />

      <GridContainer spacing={2} justifyContent="center" direction="column" style={{ padding: '7px' }}>
        {selectedReservation?.guest != null && (
          <GridItem style={{ padding: '18px' }}>
            <Typography color="textPrimary" align="center" variant="h6">
              {`${getVerbiage(verbiages, 'weblbl092')}`} {selectedReservation.guest.firstName ? `${selectedReservation.guest.lastName} ${selectedReservation.guest.firstName}! ` : selectedReservation.guest.lastName! }
              {`${getVerbiage(verbiages, 'weblbl093')}`}
            </Typography>
          </GridItem>
        )}

        {selectedReservation?.guest != null && (
          <GridItem xs={12} style={{ padding: '18px' }}>
            <Typography color='textPrimary' align='left' variant='body1' style={{ fontWeight: 'bold' }}>
            {`${getVerbiage(verbiages, 'weblbl094')}`}
            </Typography>
          </GridItem>
        )}

        {selectedReservation?.guest != null && (
          <UpsellItemCard
            onButtonClick={handleOnButtonClick}
            items={upsellImages}
          />
        )}

        {selectedReservation?.guest != null && (
          <GridItem xs={12} style={{ padding: '18px' }}>
            <Typography color='textPrimary' align='left' variant='body1' style={{ fontWeight: 'bold' }}>
            {`${getVerbiage(verbiages, 'weblbl095')}`}
            </Typography>
          </GridItem>
        )}

        {selectedReservation?.guest != null && (
          <HotelServiceCard
            onButtonClick={handleOnButtonClick}
            items={serviceImages}
          />
        )}

        <GridItem xs={12}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleClose}
            autoHideDuration={5000}
            message={message}
            action={
              <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          />
        </GridItem>
      </GridContainer>
    </>
  );
};
